var _clipPath, _clipPath2, _clipPath3, _clipPath4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 359 447",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-4195.8,-2228.19)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1062,538.889L1089,565.889L1089,637.889L1017,637.889L1017,538.889L1062,538.889Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1017,637.889L1017,538.889L1089,538.889L1089,637.889L1017,637.889Z",
    style: {
      fill: "url(#_Linear2)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1062,538.889L1089,565.889L1089,637.889L1017,637.889L1017,538.889L1062,538.889Z",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(149,26,30)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1062,538.889L1089,565.889L1062,565.889L1062,538.889Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1048.5,552.389L1062,538.889L1089,565.889L1075.5,579.389L1048.5,552.389Z",
    style: {
      fill: "url(#_Linear4)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1062,538.889L1089,565.889L1062,565.889L1062,538.889Z",
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinejoin: "round",
      stroke: "rgb(141,25,27)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1049.41,546.883C1045.22,552.351 1049.97,559.487 1049.77,565.012C1049.65,568.013 1047.1,573.138 1045.5,576.388C1043.57,580.311 1041.41,583.93 1039.81,586.698C1035.9,593.458 1031.89,600.986 1024.88,602.695C1026.04,597.929 1029.78,595.745 1032.7,592.741C1030.24,593.856 1024.06,597.355 1023.46,602.695C1025.82,604.107 1028.11,603.828 1030.21,602.34C1034.95,599 1038.27,592.479 1041.94,586.342C1045.7,580.069 1049.49,573.574 1051.19,567.856C1053.54,574.516 1058.03,579.025 1063.27,582.787C1056.52,584.089 1049.67,585.298 1044.08,587.764C1050.98,587.212 1058.79,582.977 1065.76,583.854C1070.62,584.464 1078.44,590.967 1083.89,587.053C1077.93,587.212 1073.52,585.817 1070.03,583.498C1071.43,583.581 1072.97,583.547 1074.5,583.513C1077.01,583.456 1079.51,583.399 1081.4,583.854C1082.8,584.191 1083.98,585.808 1084.6,584.921C1082.16,580.695 1072.61,582.193 1066.83,582.432C1060.81,578.605 1052.86,573.368 1051.9,564.657C1051.51,561.143 1053.5,557.557 1052.25,553.281C1052.2,556.31 1051.56,558.753 1050.83,561.103C1049.63,558.068 1048.03,550.188 1050.83,547.594C1052.41,547.551 1052.18,549.323 1052.96,550.082C1053.35,547.768 1052.38,546.805 1050.45,546.805C1050.13,546.805 1049.78,546.832 1049.41,546.883Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1008.53,587.765L1050.94,545.357L1088.26,582.683L1045.86,625.091L1008.53,587.765Z",
    style: {
      fill: "url(#_Linear6)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1049.27,545.893L1048.87,545.95L1048.62,546.273C1047.17,548.149 1046.67,550.26 1046.67,552.313C1046.7,556.773 1048.81,561.244 1048.77,564.652C1048.77,564.767 1048.77,564.876 1048.77,564.979C1048.71,567.538 1046.21,572.734 1044.6,575.947C1042.69,579.826 1040.55,583.421 1038.95,586.197C1035.42,592.343 1031.83,598.804 1026.47,601.116C1027.91,597.976 1030.79,596.099 1033.42,593.439L1032.29,591.829C1029.74,593.03 1023.24,596.501 1022.47,602.583L1022.39,603.222L1022.95,603.553C1023.15,603.675 1023.35,603.786 1023.56,603.887L1023.52,604.054L1023.78,603.991C1024.69,604.405 1025.63,604.613 1026.55,604.613L1026.56,604.613C1028.06,604.615 1029.5,604.07 1030.79,603.156C1035.83,599.571 1039.14,592.948 1042.8,586.856C1046.02,581.468 1049.29,575.901 1051.27,570.704C1053.53,575.531 1056.96,579.175 1060.86,582.231C1054.84,583.389 1048.8,584.593 1043.67,586.85L1044.16,588.761C1050.69,588.204 1057.68,584.703 1063.79,584.733C1064.42,584.733 1065.03,584.768 1065.64,584.845C1068.94,585.181 1074.53,589.24 1079.84,589.298C1081.43,589.302 1083.04,588.898 1084.48,587.866L1087.12,585.977L1084.8,586.032C1085.05,585.907 1085.28,585.715 1085.42,585.497L1085.79,584.975L1085.47,584.421C1083.63,581.428 1079.67,581.018 1075.69,580.978C1072.68,580.979 1069.54,581.302 1067.1,581.417C1061.1,577.618 1053.73,572.527 1052.89,564.547C1052.86,564.265 1052.84,563.986 1052.84,563.69C1052.83,561.58 1053.65,559.152 1053.67,556.302C1053.67,555.255 1053.55,554.148 1053.21,552.999L1051.25,553.265C1051.23,554.752 1051.06,556.089 1050.8,557.353C1050.49,555.885 1050.27,554.242 1050.27,552.744C1050.26,551.032 1050.58,549.558 1051.16,548.723C1051.19,548.775 1051.22,548.848 1051.29,548.958C1051.49,549.352 1051.59,550.094 1052.27,550.798L1053.65,552.145L1053.95,550.239C1054.01,549.856 1054.04,549.497 1054.04,549.157C1054.05,548.156 1053.73,547.214 1053.02,546.605C1052.31,546 1051.4,545.805 1050.45,545.803C1050.07,545.805 1049.68,545.836 1049.27,545.893ZM1050.76,565.051C1050.77,564.907 1050.77,564.778 1050.77,564.652C1050.76,564.273 1050.74,563.892 1050.71,563.509L1050.85,563.859C1050.85,564.156 1050.87,564.464 1050.9,564.778C1050.92,564.899 1050.93,565.021 1050.95,565.139L1050.62,566.236C1050.7,565.823 1050.75,565.426 1050.76,565.051ZM1064.97,582.772L1063.86,581.975C1062.63,581.091 1061.45,580.172 1060.33,579.197C1062.1,580.559 1063.92,581.752 1065.59,582.826C1065.38,582.804 1065.18,582.786 1064.97,582.772ZM1067.98,583.373L1068.03,583.37L1068.09,583.408C1068.05,583.397 1068.02,583.384 1067.98,583.373ZM1074.12,584.519C1075.09,584.497 1076.05,584.474 1076.98,584.474C1078.57,584.471 1080.05,584.552 1081.17,584.825C1081.49,584.898 1081.93,585.155 1082.39,585.456C1082.73,585.651 1083.04,585.91 1083.49,586.061C1083.32,586.063 1083.15,586.064 1082.98,586.064C1079.47,586.062 1076.58,585.496 1074.12,584.519Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1006.99,587.823L1050.67,544.149L1089.81,583.288L1046.13,626.961L1006.99,587.823Z",
    style: {
      fill: "url(#_Linear8)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "1024px",
    y: "629.889px",
    style: {
      fontFamily: "'Arial-BoldMT', 'Arial', sans-serif",
      fontWeight: 700,
      fontSize: 28,
      fill: "white"
    }
  }, "PDF"))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-4.3e-06,-99,99,-4.3e-06,1053,637.889)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(110,13,15)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(201,32,39)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear4",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(13.4999,-13.4999,13.4999,13.4999,1062,565.889)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(253,223,216)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "68%",
    style: {
      stopColor: "rgb(233,148,125)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(210,32,39)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear6",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(42.1233,-42.1233,42.1233,42.1233,1027.19,606.429)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(165,12,17)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(112,0,0)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear8",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(43.6268,-43.6268,43.6268,43.6268,1026.56,607.392)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(165,12,17)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(112,0,0)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.c9931465748a4504da7bcb84178e819e.svg";
export { ForwardRef as ReactComponent };